import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import type { JssNavItem } from '@core/jss-models';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { GenericLinkDirective } from '@core/jss-utils';
import { SearchBarComponent, SearchTriggerComponent } from '@search/ui';
import { DeployUrlPipe } from '@innogy/utils/environment';

import { NavbarItemComponent } from '../navbar-item/navbar-item.component';
import { NavbarDropdownComponent } from '../navbar-dropdown/navbar-dropdown.component';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'wl-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.essent.scss', './navbar.component.ed.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    GenericLinkDirective,
    NavbarDropdownComponent,
    NavbarItemComponent,
    SearchBarComponent,
    SearchTriggerComponent,
    DeployUrlPipe,
  ],
})
export class NavbarComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() navItems!: JssNavItem[];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() language!: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() brandLogoLinkUrl!: string;

  readonly #searchFeatureEnabled = inject(ENVIRONMENT_CONFIG).search.enabled;

  showSearchHeader = inject(NavigationService).searchNavigationEnabled;

  public searchEnabled() {
    return this.#searchFeatureEnabled;
  }

  public showSearchbar() {
    this.showSearchHeader.set(true);
  }
}
